// AUTO-GENERATED by scripts/gen-icons.mjs — do not edit by hand.
import Svg from '../svg/logout.svg?react';
import { Icon } from '../Icon';
import { IconProps } from '../types';

export const LogoutIcon = (props: IconProps) => <Icon svg={Svg} {...props} />;
